import { useState, useRef, useMemo, useEffect, useCallback } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../../_virtual/moment.js';
import { useChat } from '../../../hooks/use_chat.js';
import { useChatApi } from '../../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';

const useChatPeople = (filter) => {
    const [people, setPeople] = useState([]);
    const [isThinking, setThinking] = useState(false);
    const [isFetching, setFetching] = useState(false);
    const cache = useRef({});
    const { navigation } = useChat();
    const api = useChatApi();
    const filterParams = useMemo(() => {
        const params = {
            team_id: filter.teams.map(({ team_id }) => team_id).sort(),
        };
        if (filter.plan_id) {
            params.plan_id = filter.plan_id;
        }
        return params;
    }, [filter]);
    useEffect(() => {
        const getPeople = async (params) => {
            const key = JSON.stringify(params);
            const people = cache.current[key] ||
                (await fetchPeople(params).then((data) => data.people));
            cache.current[key] = people;
            setPeople(people);
        };
        const fetchPeople = async (params) => {
            setFetching(true);
            const result = await api.services.get("chat", {
                fields: { Chat: "people" },
                ...params,
            });
            setFetching(false);
            return result;
        };
        getPeople(filterParams);
    }, [filterParams]);
    const findConversations = useCallback(async () => {
        const { group_identifiers: gids } = await api.services.get("chat", {
            fields: { Chat: "group_identifiers" },
            ...filterParams,
        });
        return api.chat.get("me/conversations", {
            fields: { Conversation: "stream_channel" },
            filter: "with_exact_groups",
            gids,
        });
    }, [filterParams]);
    const createConversation = useCallback(async () => {
        const { payload } = await api.services.get("chat", {
            fields: { Chat: "payload" },
            ...filterParams,
        });
        return api.chat.post("me/conversations", { payload });
    }, [filterParams]);
    return {
        findOrCreateConversation: async () => {
            setThinking(true);
            let conversations = await findConversations();
            if (conversations.length === 0) {
                conversations = [await createConversation()];
            }
            navigation.switchToChannelView(conversations.map((c) => c.stream_channel_id).join(","));
        },
        isFetching,
        isThinking,
        people,
    };
};

export { useChatPeople };
//# sourceMappingURL=use_chat_people.js.map
